<template>
  <div class="is-inline-block" v-if="canPushGone">
    <!-- Task 467: compact = a bare icon for a list row (the CDK Import pod); the confirm is the same. -->
    <span class="icon is-clickable" v-if="compact && !isConfirmActive" data-test="cdk-push-gone-compact" @click.stop.prevent="onOpen()" v-tooltip="tooltipText">
      <b-icon pack="fal" :icon="isPending ? 'hourglass-half' : 'flag-checkered'" custom-size="fa-lg"></b-icon>
    </span>
    <div class="quick-action" v-else-if="!isConfirmActive">
      <!-- Deliberately NOT disabled while pending: requesting again is the re-arm path (zeroes the failure count and
           re-queues), which Reset Cdk Error does not do and which a push parked by disabled CDK updates needs. -->
      <button class="button" type="button" @click="onOpen()" v-tooltip="tooltipText">
        <b-icon pack="fal" :icon="isPending ? 'hourglass-half' : 'flag-checkered'" custom-size="fa-lg"></b-icon>
      </button>
    </div>
    <portal to="global-modal-portal" v-else>
      <b-modal :active.sync="isConfirmActive" :width="500" scroll="keep" :has-modal-card="true">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Push to CDK as Gone</p>
          </header>
          <section class="modal-card-body">
            <div class="notification is-danger is-light is-size-7" v-if="serverErrors.length > 0 || serverErrorMessage.length > 0">
              <p v-for="error in serverErrors" :key="error.errorMessage">
                <i class="fas fa-exclamation-circle"></i> {{ error.errorMessage }}
              </p>
              <p v-if="serverErrors.length === 0 && serverErrorMessage.length > 0">
                <i class="fas fa-exclamation-circle"></i> {{ serverErrorMessage }}
              </p>
            </div>
            <p class="is-size-7">
              Stock <strong>{{ currentInventory.stockNo }}</strong> will be queued to send to CDK with status <strong>G (Gone)</strong>.
              The push happens on the next CDK sync. Once CDK confirms it, later syncs send the normal status again.
            </p>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-danger" type="button" :class="{'is-loading': isSaving}" @click="onConfirm()" :disabled="isSaving">Push as Gone</button>
            <button class="button" type="button" @click="onCancel()" :disabled="isSaving">Cancel</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>
import inventoryService from '../../services/inventoryService'
import { createNamespacedHelpers } from 'vuex'
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'InventoryCdkPushGoneAction',
  props: {
    currentInventory: {
      type: Object,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    },
    // The caller's wording for the idle tooltip, e.g. the CDK Import pod's "Pre-trade: ...".
    tooltip: {
      type: String,
      default: 'Push to CDK as Gone'
    }
  },
  data () {
    return {
      isConfirmActive: false,
      isSaving: false,
      serverErrors: [],
      serverErrorMessage: ''
    }
  },
  computed: {
    ...mapUserGetters(['hasFeatureAccess']),
    tooltipText () {
      return this.isPending ? 'Gone push to CDK pending - click to queue it again' : this.tooltip
    },
    // Eligibility is the INVENTORY's dealer (dealerCdkEnabled), never the user's active dealer.
    canPushGone () {
      return !!(this.currentInventory && this.currentInventory.id && this.currentInventory.dealerCdkEnabled && this.hasFeatureAccess('inventory.cdk.push-gone'))
    },
    isPending () {
      return !!(this.currentInventory && this.currentInventory.cdkPushGone)
    }
  },
  methods: {
    onOpen () {
      this.serverErrors = []
      this.serverErrorMessage = ''
      this.isConfirmActive = true
    },
    onCancel () {
      this.isConfirmActive = false
    },
    onConfirm () {
      this.isSaving = true
      this.serverErrors = []
      this.serverErrorMessage = ''
      inventoryService.markCdkPushGone({ id: this.currentInventory.id }).then(response => {
        this.isSaving = false
        // A refusal is HTTP 200 { message, errors } with no model; only a returned model is success.
        if (response && response.inventoryModel) {
          this.isConfirmActive = false
          this.$buefy.toast.open({ message: 'Queued for CDK as Gone.', type: 'is-success', duration: 5000 })
          this.$emit('pushed', response.inventoryModel)
        } else {
          this.serverErrors = (response && response.errors) || []
          this.serverErrorMessage = (response && response.message) || 'The push to CDK as Gone was not accepted.'
        }
      }).catch(error => {
        this.isSaving = false
        this.serverErrorMessage = (error && (error.message || error.Message)) || 'An unexpected error occurred.'
      })
    }
  }
}
</script>
